module.exports = __webpack_public_path__ + "img/data-recovery.d517eef.png";